import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'catalog-carousel-item',
  templateUrl: './catalog-carousel-item.component.html',
  styleUrl: './catalog-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CatalogCarouselItemComponent<T> {
  public data = input.required<T>();
}
